<template>
  <div class="text" :class="{ active: currentItemIndex === thisIndex }">
      <div class="preheading" v-show="preheading" v-html="preheading"></div>
      <div class="py-1"></div>
      <div class="longtext" v-html="text"></div>
  </div>
</template>

<script>

export default {
    props: {
        index: String,
        preheading: String,
        text: String,
    },
    data() {
        return {
            currentItemIndex: 0,
            thisIndex: parseInt(this.index)
        };
    },
    mounted() {
        this.$eventHub.$on('updateVertItemIndex', (index, sender) => {
            if (this.$parent._uid === sender._uid) this.currentItemIndex = index;
        });
    }
}
</script>
